import { render, staticRenderFns } from "./GlobalC.vue?vue&type=template&id=2f87088a&scoped=true&"
import script from "./GlobalC.vue?vue&type=script&lang=js&"
export * from "./GlobalC.vue?vue&type=script&lang=js&"
import style0 from "./GlobalC.vue?vue&type=style&index=0&id=2f87088a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f87088a",
  null
  
)

export default component.exports